import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CustomProduct } from '@product/const';
import { CustomMediaComponent } from '@sdvor/shared/ui';
import { UrlModule } from '@spartacus/core';

@Component({
  selector: 'sd-product-list-image',
  templateUrl: './product-list-image.component.html',
  styleUrls: ['./product-list-image.component.scss'],
  imports: [RouterLink, CustomMediaComponent, UrlModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorProductListImageComponent {
  @Input() product: CustomProduct;
  @Input() loadImageEagerly: boolean;
  @Input() width: number;
  @Input() height: number;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() clickImage = new EventEmitter<MouseEvent | undefined>();

  onClick(event: MouseEvent): void {
    this.clickImage.emit(event);
  }
}
